module.exports = ".poster {\n  max-width: 100%; }\n"